import React from "react";
import { Card } from "reactstrap";

export default function Loading() {
  let width = document?.getElementById("navbar-width")?.offsetWidth;
  let sidebar = document?.getElementById("menu-sidebar");
  const modal = document?.getElementsByClassName("modal");
  const widthPanel = document.getElementsByClassName("content-overlay");
  // const widthSidebar = document.getElementById("menu-sidebar")?.length;
  return (
    <Card
      style={{
        height: "100%",
        width:
          modal.length > 0
            ? widthPanel.length > 0
              ? widthPanel[0].clientWidth
              : "100%"
            : sidebar
            ? width
              ? width + 2
              : 1585
            : "100%", // "100%"
        position: "fixed", // "absolute",
        top: 0,
        bottom: 0,
        right: modal.length > 0 ? 0 : "",
        zIndex: 1055, // 1048, // 9999,
        background: "rgba(225, 225, 225, 0.3)", // background: "red",
        // opacity: 8,
      }}
    >
      <div style={{ margin: "auto" }}>
        <div className="spinner-grow text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        <div className="spinner-grow text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        <div className="spinner-grow text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </Card>
  );
}
